/*
 * biobio-kit-meter.js
 * Colecao "monte seu kit". Tres pecas, uma singleton por arquivo:
 *   - KitCart: estado unico do carrinho (fetch /cart.js, conta itens elegiveis,
 *     notifica subscribers). Usado pelo medidor E pelo quick-add.
 *   - Quick-add delegado + toast (Fase 1).
 *   - Web Component <biobio-kit-meter> (Fase 2) e bottom-sheet (Fase 3).
 * Add 100% JS (/cart/add.js), NUNCA submit nativo (gotcha Yampi em template de
 * collection). NAO abre o drawer no quick-add: updateCartSummaries(false,...).
 */
(function () {
  if (window.customElements && customElements.get('biobio-kit-meter')) return;

  /* ============================ KitCart ============================ */
  var KitCart = window.__biobioKitCart || (window.__biobioKitCart = (function () {
    var count = 0;
    var seq = 0;
    var ctrl = null;
    var subs = [];

    function notify() {
      subs.forEach(function (fn) { try { fn(count); } catch (e) {} });
    }
    // A contagem de itens ELEGIVEIS (exclui produtos com a tag "combos-kits") vem
    // server-side de /cart?view=kit-count (templates/cart.kit-count.liquid), porque
    // /cart.js NAO expoe as tags do produto. Token monotonico: so a resposta mais
    // recente vale. doFetch REJEITA em falha real (rede/HTTP/parse) pra o bootstrap
    // poder re-tentar; refetch (usado por poll/eventos) engole a falha.
    function doFetch() {
      var token = ++seq;
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      // SEM Accept: application/json de proposito: com esse header o Shopify
      // ignora o ?view=kit-count e devolve o cart JSON (formato /cart.js, sem
      // "count") -> a contagem viria NaN. Sem ele, renderiza o template.
      return fetch('/cart?view=kit-count', { credentials: 'same-origin', signal: ctrl.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
        .then(function (txt) {
          if (token !== seq) return count; // resposta obsoleta: outra chamada mais nova assumiu
          var c = parseInt(JSON.parse(txt).count, 10);
          if (isNaN(c)) return Promise.reject(new Error('parse'));
          count = c;
          notify();
          return count;
        });
    }
    // Contrato usado por poll/eventos/mutacoes: NUNCA rejeita (degrada congelando o
    // valor). AbortError e demais falhas caem aqui e sao descartadas de proposito.
    function refetch() {
      return doFetch().catch(function () { return count; });
    }
    // Carga inicial com re-tentativa: se o 1o fetch falha (blip de rede, challenge
    // da Shopify, HTML no lugar do JSON), o count fica 0 e o poll nao arma (gateado
    // por count>=1) -> o medidor sumiria a sessao inteira. Tenta ate 3x com backoff
    // (800ms, 1600ms), para no 1o sucesso ou se outra chamada assumir (abort).
    function bootstrap(attempt) {
      attempt = attempt || 1;
      return doFetch().catch(function (err) {
        if (err && err.name === 'AbortError') return count; // outra chamada ja assumiu
        if (attempt < 3) {
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(bootstrap(attempt + 1)); }, attempt * 800);
          });
        }
        return count;
      });
    }
    function subscribe(fn) {
      subs.push(fn);
      return function () { var i = subs.indexOf(fn); if (i > -1) subs.splice(i, 1); };
    }
    return { refetch: refetch, bootstrap: bootstrap, subscribe: subscribe, getCount: function () { return count; } };
  })());

  /* ============================ Toast ============================ */
  function toast(msg, isError) {
    var el = document.querySelector('[data-kit-toast]');
    if (!el) {
      // Lazy-create: o toast funciona ja na Fase 1 (o card usa o toast antes de
      // o medidor da Fase 2 emitir o markup). Singleton anexado ao body.
      el = document.createElement('div');
      el.setAttribute('data-kit-toast', '');
      el.className = 'biobio-kit-toast';
      el.hidden = true;
      document.body.appendChild(el);
    }
    // a11y garantida seja qual for a origem (lazy ou markup): leitor de tela anuncia.
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = msg;
    el.classList.toggle('biobio-kit-toast--error', !!isError);
    el.hidden = false;
    // reflow pra a transicao pegar mesmo em adds em sequencia
    void el.offsetWidth;
    el.classList.add('is-visible');
    if (el._t) clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2600);
  }

  /* ============================ Quick-add ============================ */
  // Add real 1 produto. NAO abre o drawer. Atualiza badge + KitCart + toast.
  function quickAdd(variantId, title, tom, triggerBtn, onSuccess) {
    if (!variantId) return;
    if (triggerBtn) {
      if (triggerBtn.classList.contains('is-adding')) return; // anti duplo-clique
      triggerBtn.classList.add('is-adding');
      triggerBtn.setAttribute('aria-busy', 'true');
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().catch(function () { return {}; }).then(function (d) {
          throw new Error(d.description || 'HTTP ' + res.status);
        });
        return res.json();
      })
      .then(function () {
        // Sheet (Fase 3): fecha ao confirmar, SO no sucesso (erro mantem aberto).
        if (typeof onSuccess === 'function') { try { onSuccess(); } catch (e) {} }
        // Atualiza o badge/contador do tema SEM abrir o drawer (arg1=false).
        var t = window.theme;
        if (t && typeof t.updateCartSummaries === 'function' && !(t.settings && t.settings.cartType === 'page')) {
          try { t.updateCartSummaries(false, true, false); } catch (e) {}
        }
        // Sync do medidor pela fonte unica; o toast usa a contagem final.
        // A contagem do KitCart e a de itens ELEGIVEIS do progressivo (exclui a
        // tag "combos-kits"). Fora da pagina do progressivo (ex: a de aniversario,
        // onde kit e protagonista) ela mentiria: adicionar um kit mostraria
        // "Você tem 0 itens". Sem medidor na pagina o toast omite a contagem e
        // nao ESPERAMOS o refetch pra montar a mensagem. (O patch global de
        // fetch, CART_MUT la embaixo, ainda re-dispara KitCart.refetch() apos
        // qualquer /cart/add.js; o que evitamos aqui e depender do numero.)
        var nome = title + (tom ? ' ' + tom : '');
        if (document.querySelector('biobio-kit-meter')) {
          KitCart.refetch().then(function (count) {
            var itens = count + (count === 1 ? ' item' : ' itens');
            toast(nome + ' adicionado. Você tem ' + itens);
          });
        } else {
          toast(nome + ' adicionado ao carrinho');
        }
        // Evento nativo pra consumidores externos (nao re-dispara refetch, ver listener).
        document.dispatchEvent(new CustomEvent('biobio:cart-updated', {
          bubbles: true,
          detail: { source: 'kit-quick-add' },
        }));
        // Feedback "Adicionado" so no CTA simples do card. O add do sheet (que
        // fecha no sucesso) fica de fora: evita gravar "Adicionado" como texto
        // "original" num double-add rapido e grudar o label.
        if (triggerBtn && !triggerBtn.dataset.hasVariants && !triggerBtn.hasAttribute('data-kit-sheet-add')) {
          var original = triggerBtn.textContent;
          triggerBtn.classList.add('is-added');
          triggerBtn.textContent = 'Adicionado';
          setTimeout(function () {
            triggerBtn.classList.remove('is-added');
            triggerBtn.textContent = original;
          }, 1500);
        }
      })
      .catch(function (err) {
        toast('Não foi possível adicionar. Tente novamente.', true);
      })
      .then(function () {
        if (triggerBtn) {
          triggerBtn.classList.remove('is-adding');
          triggerBtn.removeAttribute('aria-busy');
        }
      });
  }
  // Exporto pro controller do bottom-sheet (Fase 3) reusar.
  window.__biobioKitQuickAdd = quickAdd;

  /* ============================ <biobio-kit-meter> ============================ */
  function parseInlineJSON(host, sel, fallback) {
    var el = host.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  // Escape pro innerHTML do nudge (o unico ponto que injeta HTML: o highlight).
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var BiobioKitMeter = (function () {
    function ctor() { return Reflect.construct(HTMLElement, [], ctor); }
    ctor.prototype = Object.create(HTMLElement.prototype);
    ctor.prototype.constructor = ctor;

    ctor.prototype.connectedCallback = function () {
      if (this._inited) return;
      this._inited = true;

      this.tiers = parseInlineJSON(this, '[data-kit-tiers]', []).slice().sort(function (a, b) {
        return a.quantidade - b.quantidade;
      });
      this.nodes = Array.prototype.slice.call(this.querySelectorAll('[data-kit-node]'));
      this.nudgeEl = this.querySelector('[data-kit-nudge]');
      this.srEl = this.querySelector('[data-kit-sr]');
      this.nudgeTpl = this.dataset.nudgeTemplate || '';
      this.lastCount = -1;
      this.lastTierIdx = -2; // -2 = ainda nao renderizou (distingue do -1 = sem tier)

      // Assina as atualizacoes (a exclusao de kit e server-side, ver KitCart).
      var self = this;
      this._unsub = KitCart.subscribe(function (count) { self.render(count); });
      // Reajusta a folga do rodape quando a barra muda de altura (quebra de linha).
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(function () { self.measure(); });
        this._ro.observe(this);
      }
      // Carga inicial com retry (ver bootstrap): sem isso, uma falha transitoria no
      // 1o fetch deixaria o medidor invisivel a sessao toda.
      KitCart.bootstrap();
    };

    ctor.prototype.disconnectedCallback = function () {
      if (this._unsub) this._unsub();
      if (this._ro) this._ro.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    };

    // Indice do maior tier batido; -1 = nenhum.
    ctor.prototype.currentTierIndex = function (count) {
      var idx = -1;
      for (var i = 0; i < this.tiers.length; i++) {
        if (count >= this.tiers[i].quantidade) idx = i;
      }
      return idx;
    };

    ctor.prototype.render = function (count) {
      var prev = this.lastCount;
      var prevTier = this.lastTierIdx;
      var tierIdx = this.currentTierIndex(count);

      // Reveal condicional: escondida com 0 item elegivel.
      var visible = count >= 1;
      this.hidden = !visible;
      document.body.classList.toggle('has-kit-meter', visible);

      // Nos: SO o tier atual fica 'done' (sage) e o proximo 'next' (anel escuro),
      // pra nao parecer que os descontos se acumulam. Pulse so no tier-up.
      // Casa por QUANTIDADE (data-qtd), nao por posicao no DOM: this.tiers e
      // ordenado mas os nodes vem na ordem crua do metaobject; o match posicional
      // acenderia o dot errado se o lojista cadastrar os tiers fora de ordem.
      var curQtd = tierIdx >= 0 ? this.tiers[tierIdx].quantidade : null;
      var nextQtd = (tierIdx + 1) < this.tiers.length ? this.tiers[tierIdx + 1].quantidade : null;
      this.nodes.forEach(function (node) {
        var q = parseInt(node.getAttribute('data-qtd'), 10);
        var wasDone = node.classList.contains('is-done');
        var done = q === curQtd;
        node.classList.toggle('is-done', done);
        node.classList.toggle('is-next', q === nextQtd);
        if (done && !wasDone && prev >= 0 && count > prev) {
          node.classList.remove('is-pulse');
          void node.offsetWidth;
          node.classList.add('is-pulse');
        }
      });

      this.renderNudge(count, tierIdx);
      this.announce(count, tierIdx, prevTier);
      if (visible) this.measure();

      this.lastCount = count;
      this.lastTierIdx = tierIdx;
    };

    // Monta a copy do nudge em texto puro + qual trecho destacar (o desconto-alvo).
    ctor.prototype.buildNudge = function (count, tierIdx) {
      var tiers = this.tiers;
      var maxIdx = tiers.length - 1;
      if (tierIdx >= maxIdx) {
        // Estado maximo: celebra e mostra o desconto conquistado (data-driven).
        var maxHl = tiers[maxIdx].percentual + '% OFF';
        return { text: 'Parabéns, você ganhou ' + maxHl, hl: maxHl };
      }
      var next = tiers[tierIdx + 1];
      var falta = next.quantidade - count;
      var faltaItens = falta === 1 ? '1 item' : falta + ' itens';
      var hl = next.percentual + '% OFF';
      var text;
      if (this.nudgeTpl) {
        // {desconto} = trecho destacado ("N% OFF"); use-o no template pro highlight
        // funcionar sem depender de o texto conter literalmente "% OFF".
        text = this.nudgeTpl
          .replace(/\{count\}/g, count)
          .replace(/\{falta_itens\}/g, faltaItens)
          .replace(/\{falta\}/g, falta)
          .replace(/\{desconto\}/g, hl)
          .replace(/\{percentual\}/g, next.percentual)
          .replace(/\{proximo\}/g, next.quantidade);
      } else {
        text = 'Mais ' + faltaItens + ' e você ganha ' + hl;
      }
      return { text: text, hl: hl };
    };

    // Nudge visivel (heroi): destaca o desconto-alvo em laranja escuro.
    ctor.prototype.renderNudge = function (count, tierIdx) {
      if (!this.nudgeEl) return;
      var n = this.buildNudge(count, tierIdx);
      var i = n.hl ? n.text.indexOf(n.hl) : -1;
      if (i === -1) {
        this.nudgeEl.textContent = n.text;
        return;
      }
      this.nudgeEl.innerHTML =
        esc(n.text.slice(0, i)) +
        '<span class="biobio-kit-meter__hl">' + esc(n.hl) + '</span>' +
        esc(n.text.slice(i + n.hl.length));
    };

    // Leitor de tela: anuncia SO quando o tier muda (evita repetir a cada item e
    // duplicar com o toast do quick-add). Carrega o estado completo.
    ctor.prototype.announce = function (count, tierIdx, prevTier) {
      if (!this.srEl || tierIdx === prevTier) return;
      var itens = count + (count === 1 ? ' item' : ' itens') + ' no carrinho';
      var msg;
      if (tierIdx < 0) {
        msg = itens + '. ' + this.buildNudge(count, tierIdx).text + '.';
      } else if (tierIdx >= this.tiers.length - 1) {
        msg = itens + '. Parabéns, você ganhou ' + this.tiers[tierIdx].percentual + '% de desconto, o maior disponível.';
      } else {
        msg = itens + '. Você tem ' + this.tiers[tierIdx].percentual + '% de desconto. ' +
          this.buildNudge(count, tierIdx).text + '.';
      }
      this.srEl.textContent = msg;
    };

    // Ajusta a variavel de altura da barra pra folga do ultimo card bater certo.
    ctor.prototype.measure = function () {
      var self = this;
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(function () {
        var h = self.offsetHeight;
        if (h) document.documentElement.style.setProperty('--kit-bar-h', h + 'px');
      });
    };

    return ctor;
  })();

  customElements.define('biobio-kit-meter', BiobioKitMeter);

  /* ==================== Bindings globais (singleton) ==================== */
  if (!window.__biobioKitMeterBound) {
    window.__biobioKitMeterBound = true;

    // Sync com mutacoes de carrinho feitas em qualquer lugar (add/qty/remove).
    // cc-cart-updated e evento jQuery (addEventListener nativo NAO pega).
    if (window.jQuery) {
      window.jQuery(window).on('cc-cart-updated', function () { KitCart.refetch(); });
    }
    // Nosso proprio evento: o quick-add ja refez o KitCart, entao ignoramos a
    // origem 'kit-quick-add' pra nao duplicar o fetch; outras origens refazem.
    document.addEventListener('biobio:cart-updated', function (e) {
      if (e.detail && e.detail.source === 'kit-quick-add') return;
      KitCart.refetch();
    });
    // Backstop pro carrinho vazio (cc-cart-updated pode nao sair sem #LimitedCartJson).
    /*
     * PORTAL: os sheets nascem dentro do card (no <li> do trilho do
     * aniversario, injetado por fetch). No iOS Safari, position:fixed dentro
     * de um container com overflow/-webkit-overflow-scrolling e tratado como
     * ESTATICO: o sheet renderizava no fluxo do trilho, soterrado pela banda
     * seguinte (print do Breno em 30/07). Adotar os sheets pro <body> tira
     * qualquer ancestral de scroll do caminho e o fixed volta a valer em
     * qualquer navegador. O kit-meter ja abre por id via delegacao no
     * document, entao o sheet pode viver em qualquer lugar do DOM.
     */
    function adoptSheets(root) {
      var escopo = root && root.querySelectorAll ? root : document;
      escopo.querySelectorAll('.biobio-kit-sheet').forEach(function (s) {
        if (s.parentElement && s.parentElement !== document.body) {
          document.body.appendChild(s);
        }
      });
    }
    adoptSheets();
    // Trilhos do aniversario chegam por fetch depois do init.
    document.addEventListener('aniv:rail-loaded', function (e) {
      adoptSheets(e.detail && e.detail.rail);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) KitCart.refetch();
    });
    window.addEventListener('focus', function () { KitCart.refetch(); });
    // Backstop no fechamento do drawer (remocao do ultimo item).
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.cart-summary__close, .js-close-cart, [data-cart-close]')) {
        setTimeout(function () { KitCart.refetch(); }, 250);
      }
    });

    // Fonte de verdade pra QUALQUER mutacao de carrinho: observa as chamadas AJAX
    // aos endpoints /cart/(add|change|update|clear) e refaz o medidor. Cobre
    // remocao/+/-/Eliminar em qualquer drawer (tema, app, Yampi) mesmo quando o
    // cc-cart-updated nao dispara (bug visto: tirar item e o medidor ficar em 25%).
    // So OBSERVA (chama o original e nao altera o comportamento). refetch tem
    // token de corrida, entao chamadas redundantes sao seguras.
    var CART_MUT = /\/cart\/(add|change|update|clear)(\.js|\?|$)/i;
    if (window.fetch && !window.__biobioKitFetchPatched) {
      window.__biobioKitFetchPatched = true;
      var _origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = _origFetch.apply(this, arguments);
        if (CART_MUT.test(url)) {
          // A resposta da mutacao e formato /cart.js (sem tags), entao NAO da pra
          // computar a contagem elegivel dela: refazemos pelo endpoint kit-count.
          p.then(function () { setTimeout(function () { KitCart.refetch(); }, 60); }, function () {});
        }
        return p;
      };
    }
    if (window.XMLHttpRequest && !window.__biobioKitXhrPatched) {
      window.__biobioKitXhrPatched = true;
      var _origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__biobioCartUrl = url;
        return _origOpen.apply(this, arguments);
      };
      var _origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        if (CART_MUT.test(xhr.__biobioCartUrl || '')) {
          xhr.addEventListener('loadend', function () { setTimeout(function () { KitCart.refetch(); }, 60); });
        }
        return _origSend.apply(this, arguments);
      };
    }

    // Delegacao do quick-add do card.
    document.addEventListener('click', function (e) {
      // Alem do CTA, os swatches de previa do card (que abrem o sheet ja no tom).
      var btn = e.target.closest && e.target.closest('.biobio-card__cta--quickadd, .biobio-card__swatch');
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.hasVariants === 'true') {
        // Abre o bottom-sheet (controller na Fase 3). Sem o controller, no-op seguro.
        if (typeof window.__biobioKitOpenSheet === 'function') {
          window.__biobioKitOpenSheet(btn);
        }
      } else {
        quickAdd(btn.dataset.variantId, btn.dataset.productTitle || '', '', btn);
      }
    });

    // CTA "ver sacola" do medidor: abre o drawer (arg1=true), fallback /cart.
    document.addEventListener('click', function (e) {
      var cartBtn = e.target.closest && e.target.closest('[data-kit-cart]');
      if (!cartBtn) return;
      e.preventDefault();
      var t = window.theme;
      if (t && typeof t.updateCartSummaries === 'function' && !(t.settings && t.settings.cartType === 'page')) {
        try { t.updateCartSummaries(true, false, false); return; } catch (err) {}
      }
      window.location.href = '/cart';
    });

    /* ==================== Bottom-sheet de tom (Fase 3) ==================== */
    var openSheetEl = null;
    var savedScrollY = 0;
    var SHEET_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';

    // Trava o scroll do fundo de forma confiavel no iOS: overflow:hidden no body
    // sozinho NAO segura o toque no iOS Safari, entao fixamos o body preservando a
    // posicao (top negativo) e restauramos ao fechar. O medidor/backdrop (fixed)
    // continuam presos ao viewport.
    // Trava por overflow:hidden na RAIZ (html+body), por CLASSE, sem
    // position:fixed e sem aritmetica de scroll. Historia das duas tentativas
    // anteriores, pra ninguem regredir:
    //   1. style.top inline + body fixed: o assets/predictive-search.js escuta
    //      clique no document e zera body.style.top/position/overflow a cada
    //      clique fora da busca; o body ficava fixo com top vazio e a pagina
    //      saltava pro topo, travada ate recarregar.
    //   2. custom property + body fixed: sobrevive ao predictive-search, mas
    //      fixar o body SOLTA todo position:sticky (header, copa-bar) e o
    //      conteudo aparenta pular um bloco; e depende de window.scrollY no
    //      momento do toque, que o iOS reporta errado durante a inercia.
    // overflow:hidden na raiz preserva a posicao de scroll e os sticky POR
    // CONSTRUCAO. iOS: o que segura o toque e o touchGuard abaixo (preventDefault
    // fora do painel), no padrao moderno de modal.
    function touchGuard(e) {
      if (!openSheetEl) return;
      var panel = openSheetEl.querySelector('.biobio-kit-sheet__panel');
      if (panel && !panel.contains(e.target)) e.preventDefault();
    }
    function lockScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('biobio-kit-noscroll');
      document.body.classList.add('biobio-kit-noscroll');
      document.addEventListener('touchmove', touchGuard, { passive: false });
    }
    function unlockScroll() {
      document.documentElement.classList.remove('biobio-kit-noscroll');
      document.body.classList.remove('biobio-kit-noscroll');
      document.removeEventListener('touchmove', touchGuard, { passive: false });
      // overflow:hidden preserva a posicao sozinho; isto e so rede de seguranca.
      if (Math.abs((window.scrollY || 0) - savedScrollY) > 1) window.scrollTo(0, savedScrollY);
    }

    function sheetFocusables(sheet) {
      return Array.prototype.slice.call(sheet.querySelectorAll(SHEET_FOCUSABLE))
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }

    // Preco do tom no rodape do sheet (21/10), como o "Seu combo" da gaveta dos kits. O mapa variante -> {p, d, o}
    // vem pronto do Liquid (money do tema) em [data-kit-sheet-precos] (snippets/biobio-product-card.liquid). Sem tom
    // marcado volta ao "inicial": com precos diferentes entre os tons (v), so o "Escolha o tom para ver o preco", sem
    // valor; com preco unico, o preco. Sheet sem o bloco: nada muda.
    function precoSheet(sheet, variantId) {
      var bloco = sheet.querySelector('[data-kit-sheet-preco]');
      if (!bloco) return;
      if (!sheet._precos) {
        var fonte = sheet.querySelector('[data-kit-sheet-precos]');
        try { sheet._precos = fonte ? JSON.parse(fonte.textContent) : {}; } catch (err) { sheet._precos = {}; }
      }
      var mapa = sheet._precos.variantes || {};
      var v = variantId && mapa[variantId];
      var inicial = !v;
      if (!v) v = sheet._precos.inicial;
      if (!v) return;
      var escolha = bloco.querySelector('[data-kit-sheet-escolha]');
      var por = bloco.querySelector('[data-kit-sheet-por]');
      var linha = bloco.querySelector('[data-kit-sheet-deline]');
      var de = bloco.querySelector('[data-kit-sheet-de]');
      var off = bloco.querySelector('[data-kit-sheet-off]');
      var semPreco = inicial && !!v.v;
      if (escolha) escolha.hidden = !semPreco;
      if (por) { por.hidden = semPreco; por.textContent = v.p || ''; }
      if (linha) linha.hidden = semPreco || !v.d;
      if (de) de.textContent = v.d || '';
      if (off) off.textContent = v.o ? '-' + v.o + '%' : '';
    }

    // Sincroniza o botao "Adicionar" + a legenda com o tom selecionado.
    function syncSheet(sheet) {
      var checked = sheet.querySelector('.swatch input[type="radio"]:checked');
      var addBtn = sheet.querySelector('[data-kit-sheet-add]');
      var current = sheet.querySelector('[data-kit-sheet-current]');
      var selLabel = checked ? checked.closest('.swatch') : null;
      // Anel de selecionado: quem pinta .swatch--selected e o JS do bundle, que NAO
      // carrega nesta colecao, entao o controller do sheet pinta aqui (senao a
      // cliente clica e nao ve feedback visual de selecao).
      var labels = sheet.querySelectorAll('.swatch');
      for (var i = 0; i < labels.length; i++) {
        labels[i].classList.toggle('swatch--selected', labels[i] === selLabel);
      }
      if (selLabel) {
        sheet._variantId = selLabel.getAttribute('data-variant-id');
        sheet._tom = selLabel.getAttribute('data-option-value') || (checked && checked.getAttribute('aria-label')) || '';
        if (addBtn) addBtn.disabled = !sheet._variantId;
        if (current) current.textContent = sheet._tom ? ('Tom: ' + sheet._tom) : 'Escolha o tom';
      } else {
        sheet._variantId = null;
        sheet._tom = '';
        if (addBtn) addBtn.disabled = true;
        if (current) current.textContent = 'Escolha o tom';
      }
      precoSheet(sheet, sheet._variantId);
    }

    // Cancela um fechamento em voo (timer + transitionend) pra o reopen rapido
    // nao ser escondido pelo hide pendente do close anterior.
    function clearPendingClose(sheet) {
      if (sheet._closeTimer) { clearTimeout(sheet._closeTimer); sheet._closeTimer = null; }
      if (sheet._closeTE) {
        var p = sheet.querySelector('.biobio-kit-sheet__panel');
        if (p) p.removeEventListener('transitionend', sheet._closeTE);
        sheet._closeTE = null;
      }
    }

    function openSheet(triggerBtn) {
      var sel = triggerBtn.getAttribute('data-sheet-target');
      var sheet = sel && document.querySelector(sel);
      if (!sheet) return;
      if (openSheetEl && openSheetEl !== sheet) closeSheet(openSheetEl);
      clearPendingClose(sheet);
      sheet._trigger = triggerBtn;

      // Swatch do CARD (data-sheet-tom): abre o sheet ja com aquele tom marcado,
      // pra a cliente so confirmar. O sheet segue sendo onde a escolha se
      // conclui, entao o fluxo de add auditado nao muda.
      var tom = triggerBtn.getAttribute('data-sheet-tom');
      if (tom) {
        var alvo = null;
        sheet.querySelectorAll('.swatch input[type="radio"]').forEach(function (input) {
          if (input.value === tom) alvo = input;
        });
        if (alvo && !alvo.disabled) {
          alvo.checked = true;
          // syncSheet le o radio marcado pra montar preco/foto/estado do botao.
        }
      } else {
        // Pelo CTA ou pelo "+N" (sem tom): abre limpo. A escolha de uma abertura anterior nao fica marcada, senao o
        // sheet reabre num tom, e num preco, que a cliente nao escolheu agora (21/10).
        sheet.querySelectorAll('.swatch input[type="radio"]:checked').forEach(function (input) {
          input.checked = false;
        });
      }

      syncSheet(sheet);
      sheet.hidden = false;
      void sheet.offsetWidth; // reflow pra a transicao do painel pegar
      sheet.classList.add('is-open');
      // openSheetEl ANTES do lock: o touchGuard le a referencia.
      openSheetEl = sheet;
      lockScroll();
      // Foco no primeiro tom disponivel (setinhas navegam o radiogroup); sem tom
      // disponivel, cai no botao fechar (o backdrop tem data-kit-sheet-dismiss mas
      // e um <div> nao-focavel, entao alvejamos a classe do botao).
      var first = sheet.querySelector('.swatch input[type="radio"]:checked:not([disabled])')
        || sheet.querySelector('.swatch input[type="radio"]:not([disabled])')
        || sheet.querySelector('.biobio-kit-sheet__close');
      if (first) first.focus();
    }

    function closeSheet(sheet) {
      if (!sheet) return;
      clearPendingClose(sheet);
      sheet.classList.remove('is-open');
      var trigger = sheet._trigger;
      var finish = function () { clearPendingClose(sheet); sheet.hidden = true; };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var panel = sheet.querySelector('.biobio-kit-sheet__panel');
      if (reduce || !panel) {
        finish();
      } else {
        sheet._closeTimer = setTimeout(finish, 340); // fallback se o transitionend nao disparar
        sheet._closeTE = function te(e) {
          if (e.target === panel && e.propertyName === 'transform') finish();
        };
        panel.addEventListener('transitionend', sheet._closeTE);
      }
      unlockScroll();
      if (openSheetEl === sheet) openSheetEl = null;
      if (trigger && typeof trigger.focus === 'function') trigger.focus(); // restaura o foco
    }

    window.__biobioKitOpenSheet = openSheet;

    // Backstop robusto (independente de mecanismo): enquanto o medidor esta visivel
    // e a aba ativa, sincroniza /cart.js a cada 2s. Cobre qualquer drawer/jQuery/app
    // que mude o carrinho sem que os caminhos rapidos (patch AJAX + cc-cart-updated)
    // peguem (bug visto: remover no drawer e o medidor so atualizar depois de 30s).
    // Para quando a aba esconde ou o medidor some (0 itens). refetch tem token de
    // corrida, entao nao conflita com as atualizacoes instantaneas.
    var kitPoll = null;
    function stopKitPoll() { if (kitPoll) { clearInterval(kitPoll); kitPoll = null; } }
    function startKitPoll() {
      if (kitPoll || document.hidden) return;
      kitPoll = setInterval(function () {
        if (document.hidden || KitCart.getCount() < 1) { stopKitPoll(); return; }
        KitCart.refetch();
      }, 2000);
    }
    KitCart.subscribe(function (count) {
      if (count >= 1 && !document.hidden) startKitPoll(); else stopKitPoll();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopKitPoll(); else if (KitCart.getCount() >= 1) startKitPoll();
    });

    // Selecao de tom por TECLADO (setas nos radios) -> 'change' dispara normal.
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('.biobio-kit-sheet .swatch input[type="radio"]')) return;
      var sheet = input.closest('.biobio-kit-sheet');
      if (sheet) syncSheet(sheet);
    });

    // Selecao por CLIQUE (mouse/touch): o input do swatch e visualmente escondido e
    // ativado via label; nesse arranjo o 'change' nativo NAO dispara/chega ao
    // document (confirmado por CDP na pagina real), mas o clique sempre borbulha e
    // o radio ja esta marcado quando chega aqui. setTimeout(0) garante ler o estado
    // apos a acao default do clique. Cobre o buraco que o 'change' sozinho deixava.
    document.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('.biobio-kit-sheet .swatch');
      if (!sw) return;
      var sheet = sw.closest('.biobio-kit-sheet');
      if (sheet) setTimeout(function () { syncSheet(sheet); }, 0);
    });

    // Fechar (backdrop / X) e Adicionar (add 100% JS via quickAdd, fecha no sucesso).
    document.addEventListener('click', function (e) {
      var dismiss = e.target.closest && e.target.closest('[data-kit-sheet-dismiss]');
      if (dismiss) {
        var ds = dismiss.closest('.biobio-kit-sheet');
        if (ds) { e.preventDefault(); closeSheet(ds); }
        return;
      }
      var add = e.target.closest && e.target.closest('[data-kit-sheet-add]');
      if (add) {
        var sheet = add.closest('.biobio-kit-sheet');
        if (!sheet || !sheet._variantId) return;
        e.preventDefault();
        quickAdd(sheet._variantId, add.getAttribute('data-product-title') || '', sheet._tom, add, function () {
          closeSheet(sheet);
        });
      }
    });

    // Teclado: Escape fecha; Tab faz focus-trap dentro do painel aberto.
    document.addEventListener('keydown', function (e) {
      if (!openSheetEl) return;
      if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closeSheet(openSheetEl); return; }
      if (e.key === 'Tab' || e.keyCode === 9) {
        var panel = openSheetEl.querySelector('.biobio-kit-sheet__panel');
        var f = sheetFocusables(openSheetEl);
        if (!f.length) return;
        var firstF = f[0];
        var lastF = f[f.length - 1];
        // Se o foco escapou do painel (clique num trecho nao-focavel -> body), o
        // proximo Tab sairia pro fundo; recaptura pro primeiro focavel.
        if (panel && !panel.contains(document.activeElement)) { e.preventDefault(); firstF.focus(); return; }
        if (e.shiftKey && document.activeElement === firstF) { e.preventDefault(); lastF.focus(); }
        else if (!e.shiftKey && document.activeElement === lastF) { e.preventDefault(); firstF.focus(); }
      }
    });

    // Defesa extra do trap: se o foco cair fora do sheet aberto por qualquer via,
    // traz de volta. Inerte quando nao ha sheet aberto (o close zera openSheetEl
    // ANTES de devolver o foco ao trigger, entao nao briga com o restore).
    document.addEventListener('focusin', function (e) {
      if (!openSheetEl || openSheetEl.contains(e.target)) return;
      var f = sheetFocusables(openSheetEl);
      if (f.length) f[0].focus();
    });
  }
})();
